import React from 'react';
import { useState, useEffect } from 'react';
import firebase from "../firebase";
import { useHistory } from "react-router-dom";
import { useSelector } from 'react-redux'
import styled from 'styled-components'
import { CircularProgress } from '@material-ui/core';
const db = firebase.firestore();

const Account = () => {
    const Section = styled.section`
        margin: 5%;
    `;

    const Title = styled.div`
        font-size: 1.1rem;
        font-weight: bold;
    `;

    const Form = styled.form`
        width: 90%;
        margin: 0 auto;
        display: flex;
    `;

    const Input = styled.input`
        margin: 2%;
        text-align: left;
        flex: 4;
    `;

    const Button = styled.button`
        flex: 1;
        margin: 2%;
        border: none;
        text-align: center;
        display: inline-block;
        background: #007DB3;
        color: #fff;
        text-decoration: none;
        letter-spacing: .05em;
        padding: 1%;
        border-radius: 3px;
        cursor: pointer;
        box-shadow: 0 2px 2px 0 rgb(0 0 0 / 14%), 0 1px 5px 0 rgb(0 0 0 / 12%), 0 3px 1px -2px rgb(0 0 0 / 20%);
        -webkit-tap-highlight-color: transparent;
        transition: .3s ease-out;
    `;

    const RedButton = styled.button`
        flex: 1;
        font-size: 1rem;
        border: none;
        text-align: center;
        display: inline-block;
        background: white;
        color: rgb(244, 67, 54);
        text-decoration: none;
        letter-spacing: .05em;
        padding: 1%;
        float: right;
        border: 1px solid rgb(244, 67, 54);
        border-radius: 3px;
        cursor: pointer;
        -webkit-tap-highlight-color: transparent;
        transition: .3s ease-out;
    `;


    const isPaid = useSelector(state => state.user.isPaid);
    const [user, setUser] = useState(null);
    const [zlaboPremium, switchZlaboPremium] = useState(false);

    let history = useHistory();

    const reAuthenticate = async (text) => {
        const user = firebase.auth().currentUser;

        let password = prompt(text);
        // console.log("password: ", password);
        if (!password) {
            // alert("パスワードが入力されていません");
            // console.log("error");
            throw Error("パスワードが入力されていません");
        }
        const credential = firebase.auth.EmailAuthProvider.credential(
            user.email,
            password
        );
        // console.log("crediential: ", credential);
        return user.reauthenticateWithCredential(credential).then(() => {
            // User re-authenticated.
            // console.log("reauthenticate success");
        }).catch((error) => {
            alert("認証エラーです。");
        });
    }

    const deleteAccount = () => {
        const user = firebase.auth().currentUser;

        const deleteUser = () => {
            user.delete().then(() => {
                alert("アカウントが消去されました。");
                // console.log("account deleted");
                history.push("/アップグレード");
            }).catch((error) => {
                // An error ocurred
                // ...
                alert(error.message);
            });
        }

        if (window.confirm("アカウントを消去します。この操作は取り消せません")) {
            // console.log("isPaid: ", isPaid);
            if (isPaid) {
                alert("アカウントを消去するには、アップグレードの停止が必要です。");
            } else {
                if (user.providerData[0].providerId === "password") {
                    reAuthenticate("パスワードを入力してください。").then(() => {
                        // console.log("start delete");
                        deleteUser();
                    }).catch(() => {
                        alert("認証エラーです。");
                        throw Error;
                    });
                } else {
                    deleteUser();
                }
            }
        }
    }

    const Background = styled.div`
        background-color:  rgba(255,255,255,0.5);;
        width: 100%;
        height: 100%;
        position: absolute;
    `;

    const Wrapper = styled.div`
        text-align: center;
        margin-top: 200px;
  `;

    const Loading = () => {
        return (
            <Background>
                <Wrapper>
                    <CircularProgress />
                </Wrapper>
            </Background>
        );
    }


    useEffect(() => {
        const unregisterAuthObserver = firebase.auth().onAuthStateChanged(user => {
            if (user) {
                setUser(user);
                db.collection('customers')
                    .doc(user.uid)
                    .onSnapshot(async (snapshot) => {
                        // console.log("zlabo-premium: ", snapshot.data());
                        const zlabo_premium = snapshot.data().zlabo_premium;
                        // console.log("zlabopremiu: ", zlabo_premium);
                        if (zlabo_premium) {
                            switchZlaboPremium(true);
                        } else {
                            switchZlaboPremium(false);
                        }
                    });
            } else {

            }
        });
        return () => unregisterAuthObserver(); // Make sure we un-register Firebase observers when the component unmounts.
    }, []);


    const Logout = () => {
        firebase.auth().signOut();
        history.push("/アップグレード");
    }

    if (!!user) {
        return (
            <Section>
                {((user.providerData[0].providerId === "password") && !zlaboPremium) &&
                    (<><Title>メールアドレスの変更</Title>
                        <div style={{ fontSize: "0.75rem" }}>現在のメールアドレス: {user.email}</div>
                        <Form
                            onSubmit={(e) => {
                                e.preventDefault();
                                const user = firebase.auth().currentUser;
                                const target = e.target;
                                const email = target.email.value;
                                reAuthenticate("パスワードを入力してください。").then(() => {
                                    user
                                        .updateEmail(email)
                                        .then(function () {
                                            // console.log("pattern 1");
                                            alert("メールアドレスを更新しました。送信されたリンクをクリックし、本人確認を完了してください。");
                                        })
                                        .catch(function (error) {
                                            // An error happened.
                                            // console.log("pattern 2");
                                            // console.log("error: ", error);
                                            alert(error.message);
                                        });
                                }).catch((error) => {
                                    alert(error);
                                });

                            }}
                        >
                            <Input type="email" name="email"></Input>
                            <Button type="submit">送信</Button>
                        </Form></>)}
                {zlaboPremium &&
                    (<div style={{ fontSize: "1rem" }}>現在のメールアドレス: {user.email}<br /></div>)
                }
                {(user.providerData[0].providerId === "facebook.com" && user.email) &&
                    (<div style={{ fontSize: "1rem" }}>現在のメールアドレス: {user.email}<br /></div>)
                }
                {(user.providerData[0].providerId === "google.com") &&
                    (<div style={{ fontSize: "1rem" }}>現在のメールアドレス: {user.email}<br /></div>)
                }
                {((user.providerData[0].providerId === "password") || (user.providerData[0].providerId === "facebook.com" && user.email)) &&
                    <><Title>メールアドレスの確認</Title>
                        <Form
                            onSubmit={(e) => {
                                e.preventDefault();
                                const user = firebase.auth().currentUser;

                                user.sendEmailVerification()
                                    .then(() => {
                                        // Email verification sent!
                                        // ...
                                        console.log("email sent");
                                        alert("このメールアドレスに送信されたリンクをクリックし、本人確認を完了してください。")
                                    });
                            }}
                        >
                            <div style={{ flex: 2 }}>{user.emailVerified ? '確認済み' : '未確認'}
                            </div>
                            <div>{!user.emailVerified && <Button type="submit">確認メールを再送</Button>}</div>
                        </Form></>}
                {(user.providerData[0].providerId === "password") &&
                    <><Title>パスワードの変更</Title>
                        <Form
                            onSubmit={(e) => {
                                e.preventDefault();
                                const user = firebase.auth().currentUser;
                                const target = e.target;
                                const newPassword = target.password.value;
                                if (user.providerData[0].providerId === "password") {
                                    reAuthenticate("現在のパスワードを入力してください。").then(() => {
                                        user
                                            .updatePassword(newPassword)
                                            .then(function () {
                                                alert("パスワードを更新しました");
                                            })
                                            .catch(function (error) {
                                                alert("入力内容を確認してください。");
                                            });
                                    }).catch((error) => {
                                        console.log(error);
                                        alert(error);
                                    });
                                } else {
                                    user
                                        .updatePassword(newPassword)
                                        .then(function () {
                                            alert("パスワードを更新しました");
                                        })
                                        .catch(function (error) {
                                            alert("入力内容を確認してください。");
                                        });
                                }
                            }}
                        >
                            <Input type="password" name="password"></Input>
                            <Button type="submit">送信</Button>
                        </Form></>}
                {/* <div>ステータス: {checkIsPaid() ? "アップグレード済み" : "無料"}</div> */}
                <br />
                <button className="simple-button" onClick={() => history.push("/アップグレード")}>  戻る  </button>
                <>        </>
                <button className="simple-button" onClick={() => Logout()}>  ログアウト  </button>
                <RedButton onClick={() => deleteAccount()}>アカウントの削除</RedButton>
            </Section>
        );
    } else {
        return (
            <section style={{ position: "relative" }}>
                <Loading />
            </section>
        );
    }
}

export default Account;